import { Component, h } from '@stencil/core';

export interface AhaAiTag extends HTMLAhaAiTagElement {}

/**
 * Shows the content in a tag.
 */
@Component({
  tag: 'aha-ai-tag',
})
export class AhaAiTag {
  render() {
    return (
      <aha-tag
        color="var(--theme-alert-ai-background)"
        textColor="var(--theme-alert-ai-icon-color)"
      >
        AI
      </aha-tag>
    );
  }
}
